import promis from './promis'
import API from '@/api/index'

/* eslint-disable */

export default {
	getHomeData: function (codelist, parms) {
		return promis.get1(API.Homeapi + codelist, parms)
	},
	postHomeData: function (codelist, parms) {
		return promis.post(API.Homeapi + codelist, parms)
	},
	getOFid: function (id) {
		return promis.get1(API.getOFid + id, '')
	},
	deleteImg: function (url, params) {
		return promis.delete(API.safetyApi + url, params)
	},
	isBmd: function (codelist, params) {
		return promis.get1(API.bmdapi + codelist, params)
	},
	baseUpload: function (url, parms) {
		return promis.post(API.baseUpload + url, parms)
	},
	//获取来电识别信息
	getPhoneData: function (parms) {
		return promis.get1(API.safetyApi + '/securityCenter/protected/checkPhone' + parms)
	},
	//判断微信是否绑定
	getWcStatus: function (parms) {
		return promis.get1(API.safetyApi + '/securityCenter/protected/queryWechatBindingStatus' + parms)
	},
	//查询微信信息推送绑定情况
	getMsgStatus: function (parms) {
		return promis.get1(API.safetyApi + '/securityCenter/protected/queryWechatMsgBinding' + parms)
	},
	//查询登录日志
	getLoginRecord: function (parms) {
		return promis.get1(API.safetyApi + '/securityCenter/protected/queryLoginRecord' + parms)
	},
	//查询登录历史是否异常
	getAbnormalLogin: function (parms) {
		return promis.get1(API.safetyApi + '/securityCenter/protected/queryLoginRecordStatus' + parms)
	},
	//查询登录设备
	getLoginDevice: function (parms) {
		return promis.get1(API.safetyApi + '/securityCenter/protected/queryLoginDevice' + parms)
	},
	//查询登录设备是否异常
	getAbnormalDevice: function (parms) {
		return promis.get1(API.safetyApi + '/securityCenter/protected/queryLoginDeviceStatus' + parms)
	},
	getRytx: function (url, parms) {
		return promis.get1(API.Homeapi + 'honorSystem/protected/' + url, parms)
	},
	getSubmitData: function (params) {
		return promis.post(API.Homeapi + 'honorSystem/protected/submitMyHonorList', params)
	},
	potRytx: function (url, parms) {
		return promis.post(API.Homeapi + 'honorSystem/protected/' + url, parms)
	},
	getJFSC: function (url, parms) {
		return promis.get1(API.URL_JFSC + '/tkapi/tkapi/hashMobile/' + url, parms)
	},
	getCom: function (url, parms) {
		return promis.get1(API.Comapi + url, parms)
	},
	getUserCode: function (url, parms) {
		return promis.get1(API.Bindapi + url, parms)
	},
	getUserCodeTwo: function (url, parms, headers) {
		return promis.get2(API.Bindapi + url, parms, headers)
	},
	getCardsData: function (url, parms) {
		return promis.post(API.URL_COUPON + url, parms)
	},
	getJwt: function (url, parms) {
		return promis.post(API.URL_COUPON + url, parms)
	},
	getWXTXData: function (url, parms, headers) {
		return promis.get2(API.WXTX_URL + url, parms, headers)
	},
	postWXTXData: function (url, parms, headers) {
		return promis.post1(API.WXTX_URL + url, parms, headers)
	},
	postSign: function (url, parms, headers) {
		return promis.post1(API.Comapi + url, parms, headers)
	},
	getPamt: function (url, parms) {
		return promis.get1(API.URL_COUPON + url, parms)
	},
	postUnified: function (url, parms, headers) {
		return promis.post1(API.Bindapi + url, parms, headers)
	},
	postApi: function (url, parms, headers) {
		return promis.post1(API.API_URL + url, parms, headers)
	},
	getApi: function (url, parms, headers) {
		return promis.get2(API.API_URL + url, parms, headers)
	},
	getDigitinfo: function (url, parms, headers, fun) {
		return promis.get2(API.digitinfo + url, parms, headers)
	},
	getYtginfo:function (url, parms, headers) {
		return promis.get2(API.ytgApi + url, parms, headers)
	},
	postCloud: function (url, parms, headers) {
		return promis.post1(API.cloudapi + url, parms, headers)
	},
	postDigitinfo: function (url, parms, headers, fun) {
		return promis.post1(API.digitinfo + url, parms, headers)
	}
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/servers/postageMgr.js